import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'image', 'counter']
  static values = { index: { type: Number, default: 0 } }

  open({ params: { index } }) {
    this.indexValue = index
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  prev() {
    this.indexValue = (this.indexValue - 1 + this.imageTargets.length) % this.imageTargets.length
  }

  next() {
    this.indexValue = (this.indexValue + 1) % this.imageTargets.length
  }

  indexValueChanged() {
    this.imageTargets.forEach((img, i) => img.classList.toggle('hidden', i !== this.indexValue))

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.indexValue + 1} / ${this.imageTargets.length}`
    }
  }
}
